// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { urlsConstants } from '../../../_constants/urls.constant';

function SsoListener({ dispatch, history }): React.Node {
  useEffect(() => {
    let processed = false;

    const ALLOWED = new Set([
      'http://localhost:3000',
      'http://127.0.0.1:5500',
      'https://metadoctors.com.br',
      'https://www.metadoctors.com.br',
    ]);

    const listener = async (event) => {
      console.log('[SSO] onMessage origin=', event.origin, 'data=', event.data);

      if (!ALLOWED.has(event.origin)) {
        console.warn('[SSO] origem não autorizada:', event.origin);
        return;
      }
      if (processed) {
        console.log('[SSO] ignorando mensagem duplicada');
        return;
      }

      const { tokenEmpresa, tokenUsuario } = event.data || {};
      if (!tokenEmpresa || !tokenUsuario) {
        console.warn('[SSO] tokens inválidos recebidos:', event.data);
        return;
      }

      try {
        const url = urlsConstants.INTEGRACAO_SSO_IFRAME || '/auth/integracao';
        console.log('[SSO] POST', url);

        const resp = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tokenEmpresa, tokenUsuario }),
          credentials: 'include', // se usa cookie de sessão
          mode: 'cors',
        });

        console.log('[SSO] resp status=', resp.status);
        // if (!resp.ok) {
        //   dispatch.alert && dispatch.alert.error && dispatch.alert.error({ message: 'Falha na autenticação SSO' });
        //   return;
        // }

        const data = await resp.json().catch(() => ({}));
        console.log('[SSO] resp body=', data);

        if (data.acao === 'LOGIN_OK') {
          try {
            console.log('[SSO] ssoLogin cpf=', data.cpf);
            await dispatch.authentication.ssoLogin({ cpf: data.cpf, perfil: 0 });

            // hidrata user/perfis/roles como o app faz no boot
            if (dispatch.authentication.doRefresh) {
              console.log('[SSO] doRefresh()…');
              await dispatch.authentication.doRefresh();
              console.log('[SSO] doRefresh OK');
            }

            // SAI do /login e deixa o app seguir o fluxo normal (/, /m, etc.)
            processed = true;
            console.log('[SSO] redirect -> /');
            history.replace('/');

          } catch (err) {
            console.warn('[SSO] ssoLogin falhou:', err);
            if (err && err.error_description === 'MULTI_PERFIL') {
              processed = true;
              console.log('[SSO] MULTI_PERFIL -> /selectPerfil');
              history.push({ pathname: '/selectPerfil', state: { cpf: data.cpf } });
              return;
            }
          }

        } else if (data.acao === 'USUARIO_NAO_CADASTRADO') {
          dispatch.alert && dispatch.alert.success && dispatch.alert.error({ message: 'Usuário não cadastrado.' });
        } else if (data.acao === 'USUARIO_INATIVO') {
          dispatch.alert && dispatch.alert.success && dispatch.alert.error({ message: 'Usuário inativo' });
        }
      } catch (err) {
        console.error('[SSO] erro no fluxo:', err);
        dispatch.alert && dispatch.alert.error && dispatch.alert.error({ message: 'Erro no fluxo SSO' });
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [dispatch, history]);

  return null;
}

export default withRouter(connect()(SsoListener));
